import { Element } from '../../../common/html/element'
import { Icon } from '../../../common/html/icon'
import { formatText } from '../../../helpers/value'
import {
  SENTIMENT_COLOR_BY_ID,
  SENTIMENT_ICON_BY_ID,
} from '../../common/constant'

export const LabelPanel = ({ data }) => {
  const { sentimentId } = data

  const color = SENTIMENT_COLOR_BY_ID[sentimentId]

  return (
    <div className="dFlex alignItemsCenter gap1">
      <Icon
        className={SENTIMENT_ICON_BY_ID[sentimentId]}
        style={{ fontSize: 18, color }}
      />
      <Element className="fw600" style={{ fontSize: 14, color }}>
        {formatText(data?.alertCriteriaName)}
      </Element>
    </div>
  )
}
